<template src="./list.pug" lang="pug"></template>

<script>
import vSelect from 'vue-select'
import { TheMask } from 'vue-the-mask'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import TreeGrid from '../../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import language from '../../../../../build/language/index.js'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'EstablishmentsList',

  components: {
    vSelect,
    TheMask,
    PageTitle,
    ButtonPrimary,
    FilterPortlet,
    TreeGrid
  },

  data () {
    return {
      gridId: '#establishmentsGrid',
      treeGridCfg: {},
      isLoadingData: true,
      exportUrl: EXPORT_TREEGRID,
      showTreegrid: false,
      filter: {
        nome: null,
        cnpj: null,
        uf: null,
        cidade: null,
        grupo: null,
        situacoes: null
      },
      situationList: [
        {
          id: 'A',
          value: 1,
          nome: this.$t('estabelecimentos.labels.ativo'),
          checked: true
        },
        {
          id: 'I',
          value: 0,
          nome: this.$t('estabelecimentos.labels.inativo'),
          checked: true
        }
      ],
      disableSearchButton: false,
      selectedStatuses: [0, 1],
      uf: [],
      cities: [],
      establishmentsGroup: [],
      result: {}
    }
  },

  watch: {
    situationList: {
      handler (val) {
        this.selectedStatuses = []
        val.forEach(st => {
          if (st.checked) {
            this.selectedStatuses.push(st.value)
          }
        })
      },
      deep: true
    }
  },

  methods: {
    validate (isScrollable = true) {
      let self = this
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.showTreegrid = true
            startTreeGridLoading(self.gridId, undefined, isScrollable)
            this.search(isScrollable)
          }
        })
    },

    search (isScrollable = true) {
      this.disableSearchButton = true
      this.filter.nome = this.filter.nome ? this.filter.nome : null
      this.filter.cnpj = this.filter.cnpj ? this.filter.cnpj : null
      this.filter.lang = language.getCookieByName('language')
      this.loadEstablishments(isScrollable)
    },

    edit (establishmentId) {
      this.$store.dispatch('setEstablishmentToEdit', establishmentId).then((response) => {
        this.$router.push(PATHS.NEW_ESTABLISHMENT)
      })
    },

    newEstablishment () {
      this.$router.push(PATHS.NEW_ESTABLISHMENT)
    },

    moveEstablishment () {
      this.$router.push(PATHS.MOVE_ESTABLISHMENT)
    },

    loadEstablishments (isScrollable = true) {
      this.filter.url = 'establishment/listDetails'
      this.filter.situacao = false
      this.filter.idioma = language.getCookieByName('language')
      this.$store.dispatch('getEstablishmentsToTreeGrid', this.filter)
      .then((response) => {
        if (window.DisposeGrids) {
          window.DisposeGrids()
        }
        this.treeGridCfg = response.data.Cfg.Layout
        this.result = response.data
        window.Grids.editEstablishment = (row) => {
          this.edit(row.id)
        }
        stopTreeGridLoading(this.gridId, isScrollable)
        this.disableSearchButton = false
      }).catch((error) => {
        this.$root.$refs.notification.error(error.message)
        stopTreeGridLoading(this.gridId, isScrollable)
        this.disableSearchButton = false
      })
    },

    loadEstablishmentGroups () {
      this.$store.dispatch('getEstablishmentGroups')
        .then((response) => {
          this.establishmentsGroup = response
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
        })
    }
  },

  created () {
    this.loadEstablishmentGroups()
    this.validate(false)
  }
}
</script>

<style scoped>
.margin-right {
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// List.vue?8a697998